/**
 * Client-side token-bucket rate limiter.
 * Tracks tokens per endpoint type, refilling over time.
 */

const LIMITS = {
    lookup: { maxTokens: 100, refillPerMinute: 100 },
    search: { maxTokens: 10, refillPerMinute: 10 },
    facets: { maxTokens: 2, refillPerMinute: 2 },
};

const STORAGE_KEY = 'hl_rate_limit';

function getState() {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    try { return JSON.parse(raw); } catch { return {}; }
}

// eslint-disable-next-line no-unused-vars
function saveState(state) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
}

function getBucket(type) {
    const state = getState();
    const limit = LIMITS[type];
    if (!limit) throw new Error(`Unknown rate limit type: ${type}`);

    const now = Date.now();
    let bucket = state[type];

    if (!bucket) {
        bucket = { tokens: limit.maxTokens, lastRefill: now };
    }

    // Refill tokens based on elapsed time
    const elapsed = now - bucket.lastRefill;
    const refillAmount = (elapsed / 60000) * limit.refillPerMinute;
    bucket.tokens = Math.min(limit.maxTokens, bucket.tokens + refillAmount);
    bucket.lastRefill = now;

    return bucket;
}

/**
 * Check if a request can proceed and consume a token.
 * @param {'lookup'|'search'|'facets'} type
 * @returns {{ allowed: boolean, retryAfterMs: number }}
 */
export function consumeToken(type) {
    /* 
    // TO RE-ENABLE RATE LIMITING: Uncomment this block and delete the return below.
    const bucket = getBucket(type);
    const limit = LIMITS[type];

    if (bucket.tokens >= 1) {
        bucket.tokens -= 1;
        const state = getState();
        state[type] = bucket;
        saveState(state);
        return { allowed: true, retryAfterMs: 0 };
    }

    const msPerToken = 60000 / limit.refillPerMinute;
    const deficit = 1 - bucket.tokens;
    const retryAfterMs = Math.ceil(deficit * msPerToken);
    return { allowed: false, retryAfterMs };
    */

    return { allowed: true, retryAfterMs: 0 };
}

/**
 * Get remaining tokens for a type (for UI display).
 */
export function getRemainingTokens(type) {
    const bucket = getBucket(type);
    return Math.floor(bucket.tokens);
}
